import { ServiceCerca } from 'services/modulos/serviceCerca';

export const TOTAL_AIS = 34;

// AIS01, AIS02 ... AIS34 — mesmo nome usado nas cercas de sistema do backend
export const aisNames = Array.from(
  { length: TOTAL_AIS },
  (_, index) => `AIS${String(index + 1).padStart(2, '0')}`
);

export type AisPath = { lat: number; lng: number }[];

let cachedRequest: Promise<AisPath[]> | null = null;

// Busca as geometrias das AIS (cercas de sistema nomeadas AISnn) e converte
// para o formato do Google Maps. Índice do array = número da AIS - 1.
export const fetchAllAisPolygons = (): Promise<AisPath[]> => {
  if (!cachedRequest) {
    cachedRequest = Promise.all(
      aisNames.map(nome =>
        ServiceCerca.getCercaSystem(nome)
          .then(
            cerca =>
              cerca?.geom?.points?.map((p: { x: number; y: number }) => ({
                lat: p.y,
                lng: p.x,
              })) || []
          )
          .catch((): AisPath => [])
      )
    ).then(polygons => {
      // resultado totalmente vazio indica falha geral (rede/token):
      // não mantém em cache para permitir nova tentativa
      if (polygons.every(p => p.length === 0)) {
        cachedRequest = null;
      }
      return polygons;
    });
  }

  return cachedRequest;
};
